




import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator'

import CustomEditor from '../../../../../Editor/CustomEditor'
import { IntegrationNode } from '../../logic/IntegrationNode'

@Component({
  components: {
  },
})
export default class IntegrationSidebar extends Vue {
  @Prop() node!: IntegrationNode

  @Prop() editor!: CustomEditor
}
